import { createSelector } from '@reduxjs/toolkit';
import { Store } from 'components/common/types/Store.types';

export const getEnvironmentId = createSelector(
  [(state: Store) => state.environment.environmentId],
  (environmentId) => environmentId,
);
